export default (location) => {
    const _maps = {
        international: 'Quốc tế',
        us: 'Thường (US)',
        vn: 'Việt Nam',
        sg: 'Singapore (VN Post)',
    }

    return _maps[location] || location
}
